import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        langs: {
            namespaced: true,
            state: {
                types: [
                    "Català",
                    "Castellano",
                    "English",
                    "Français",
                ],
                actual: null,
            },
            mutations: {
                toggle(state, lang) {
                    state.actual = lang;
                }
            }
        },
        visit: {
            namespaced: true,
            state: {
                type: null
            },
            getters: {
                getType: state => {
                    return state.type;
                }
            },
            mutations: {
                toggle(state, type) {
                    state.type = type;
                }
            }
        },
        connection: {
            namespaced: true,
            state: {
                connected: true
            },
            mutations: {
                toggle(state, connected) {
                    state.connected = connected;
                }
            }
        }
    }
})



// WEBPACK FOOTER //
// ./src/store.js